import { Typography } from '@mui/material';
import React, { FC, ReactNode } from 'react'
import { FilterField } from './styled';
import { COLORS } from '@/constants';

type SearchFilterFieldProps = {
  icon: ReactNode,
  value: string,
  isShow: boolean
}

export const SearchFilterField: FC<SearchFilterFieldProps> = ({
  icon,
  value,
  isShow
}) => {
  if (!isShow) return null;
  return (
    <FilterField>
      {icon}
      <Typography
        color={COLORS['primary/900']}
        fontSize={12}
        fontWeight={700}
        lineHeight={'125%'}
        noWrap
      >
        {value}
      </Typography>
    </FilterField>
  )
}
